"use client";

import { FunctionComponent } from "react";
import { TailwindColors } from "@components/common/types/general";
import { Wrapper } from "./arrow.styles";

export interface ArrowProps {
    /**
     * Color of the arrow.
     */
    color?: keyof TailwindColors | undefined;

    /**
     * Class name of the arrow.
     */
    className?: string;
}

export const Arrow: FunctionComponent<ArrowProps> = ({ color, className }) => {
    return <Wrapper color={color} className={className}></Wrapper>;
};
